import axios from "axios";

export async function getLocationTimeZone(lat, lng) {
    const apikey = process.env.VUE_APP_HERE_API_KEY;

    const url = `https://reverse.geocoder.ls.hereapi.com/6.2/reversegeocode.json?mode=retrieveAreas&prox=${lat},${lng}&gen=9&apiKey=${apikey}&locationattributes=adminInfo,timeZone`;

    return axios({
        method: "GET",
        url: url
    }).then(res => {
        return res;
    }).catch(e => {
        if (e.response) {
            return e.response;
        }
        return false;
    });
}